module.exports = __webpack_public_path__ + "static/media/diet.7c47751d.png";